import checkNotificationType from '../../../helpers/checkNotificationType'
import { NotificationItem } from '../../../types'
import EventInvitationControls from '../EventInvitationControls'
import FollowingControls from '../FollowingControls'
import { FC } from 'react'

type ControlsWrapperProps = {
  isPopup: boolean
  notification: NotificationItem
}

const ControlsWrapper: FC<ControlsWrapperProps> = ({
  notification,
  isPopup,
}) => {
  const { isEventRelated, isFollowingRelated } =
    checkNotificationType(notification)

  switch (true) {
    case isEventRelated:
      return <EventInvitationControls notification={notification} />
    case isFollowingRelated:
      return <FollowingControls notification={notification} isPopup={isPopup} />
    default:
      return null
  }
}

export default ControlsWrapper
